import {
  useCurrentLanguage,
  useGetPackagePropChatStatusQuery,
  useLocalState,
  usePackageId,
  useProjectId,
} from '@consigli/hooks';
import { useCallback } from 'react';

import { type Message } from '@/util/interfaces';

import { useAgentChatSession } from './use-agent-chat-session';

export const usePropChat = () => {
  const projectId = useProjectId();
  const packageId = usePackageId();
  const language = useCurrentLanguage();
  const { sendMessage, session } = useAgentChatSession();

  const [propChatDisclaimerShown, setPropChatDisclaimerShown] = useLocalState<boolean>(
    'prop-chat-disclaimer-shown',
    false,
  );
  const { data: status, isLoading: loadingStatus } = useGetPackagePropChatStatusQuery({
    projectId,
    packageId,
  });

  const onMessage = useCallback(
    (message: Message) => sendMessage(message, language),
    [language, sendMessage],
  );

  return {
    disabled: status?.ready === false,
    isResumedChat: session.isResumedChat,
    loadingAnswer: session.isStreaming,
    loadingStatus,
    messages: session.messages,
    onMessage,
    propChatDisclaimerShown,
    setPropChatDisclaimerShown,
  };
};
